export default {
    PORT : process.env.PORT || 8002,
    // API_ENDPOINT: "http://localhost:8002/api",
    API_ENDPOINT: 'https://morning-garden-99142.herokuapp.com/api',
    TOKEN_KEY: 'plan-client-auth-token'
}